<div class="dialog dialog-medium dialog-flex-direction-column">
    <h4 class="dialog-inner h4-blue">How is Disability Defined?</h4>
    <div class="dialog-inner">MGIS uses an “actual procedures” definition of disability. We determine the insured’s
        actual procedures from the insured’s billing records, including CPT, CDT/ADA, and modifiers. If we can then
        determine that the disability prevents the claimant from performing one or more of these actual procedures, and
        there is a requisite loss of income, the insured claimant will be considered disabled.</div>

    <div class="dialog-inner-buttons">
        <button class="button-mgis" (click)="close()" class="chat-button chat-button-define" mat-flat-button>Done</button>
    </div>